/**
 * Logo ufficiale Equal CRM (fornito dal proprietario il 2026-10-09).
 * Due versioni: scura per i temi chiari, bianca per il tema scuro. Quale mostrare lo decide
 * il CSS su [data-theme] (index.css, .brand-logo-*), così il logo segue il cambio di tema
 * senza rerender.
 */
export default function BrandLogo({ height = 40, className = '' }: { height?: number; className?: string }) {
  return (
    <span className={'brand-logo ' + className} style={{ height }}>
      <img src="/brand/equal-crm-logo-dark.png" alt="Equal CRM" className="brand-logo-on-light" style={{ height }} />
      <img src="/brand/equal-crm-logo-light.png" alt="" aria-hidden="true" className="brand-logo-on-dark" style={{ height }} />
    </span>
  )
}
